import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { imgUrl } from "@/lib/api";

const SPAN = {
  tall: "md:col-span-4 md:row-span-2",
  wide: "md:col-span-8",
  md: "md:col-span-4",
};

const Tile = ({ it, i }) => (
  <motion.div
    layout
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
    className={`group relative h-[340px] overflow-hidden rounded-[3px] border border-[#163D43] bg-[#0B2326] md:h-auto ${SPAN[it.size] || SPAN.md}`}
    data-testid={`portfolio-item-${i}`}
  >
    <img src={imgUrl(it.image_url)} alt={it.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#041214]/90 via-transparent to-transparent" />
    <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-4 p-6">
      <div>
        <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#2DD4BF]">{it.category}</p>
        <h3 className="font-display mt-1 text-xl font-semibold text-teal-50 md:text-2xl">{it.title}</h3>
      </div>
      <span className="font-mono-x text-xs text-teal-200">{String(i + 1).padStart(2, "0")}</span>
    </div>
  </motion.div>
);

export const Portfolio = ({ items }) => {
  const [filter, setFilter] = useState("Todos");
  const cats = useMemo(() => ["Todos", ...new Set(items.map((i) => i.category).filter(Boolean))], [items]);
  const shown = filter === "Todos" ? items : items.filter((i) => i.category === filter);
  return (
    <section id="portfolio" className="bg-[#041214] py-24 md:py-36" data-testid="portfolio-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-12 flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <div>
            <Eyebrow n="03">Portfólio</Eyebrow>
            <Reveal><h2 className="font-display mt-6 text-4xl font-semibold uppercase leading-[0.95] text-teal-50 md:text-6xl">Trabalhos <span className="font-serif-i normal-case text-[#2DD4BF]">selecionados</span></h2></Reveal>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="portfolio-filters">
            {cats.map((c) => (
              <button key={c} onClick={() => setFilter(c)} data-testid={`portfolio-filter-${c.toLowerCase().replace(/\s+/g, "-")}`} className={`rounded-full border px-4 py-2 text-sm transition-colors ${filter === c ? "border-[#2DD4BF] bg-[#2DD4BF] text-[#041214]" : "border-[#163D43] text-teal-100 hover:border-[#2DD4BF]/60"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>
        <motion.div layout className="grid grid-cols-1 gap-5 md:auto-rows-[280px] md:grid-cols-12 md:[grid-auto-flow:dense]">
          {shown.map((it, i) => <Tile key={it.id} it={it} i={i} />)}
        </motion.div>
        {items.length === 0 && <p className="text-teal-200">Portfólio em breve.</p>}
      </div>
    </section>
  );
};
